const getCustomizationTrackedEvents = state => state.cards.trackedEvents.customization;

export default getCustomizationTrackedEvents;
